import { existsInColorGroups } from '../../../../../../lib/utils/colors'
import {
  deriveAvailableProducts,
  deriveColorPriceRanges,
  deriveColorsWithUnavailable,
} from '../../../../../../lib/utils/product-availability'
import {
  ColorGroup,
  ProductAvailabilitySlice,
  ProductGroupWithProductAvailability,
} from '../../../../../../types/graphql/product'

/**
 * @deprecated Use your own types based on your query's gen typed data.
 */
export type ProductPageProductGroup = Omit<
  ProductGroupWithProductAvailability,
  'featuredProduct'
> & {
  handle: string
}

/**
 * @deprecated Use your own types based on your query's gen typed data.
 */
export namespace ProductPageProductGroup {
  export function getAvailableProducts(productsForAvailability?: ProductAvailabilitySlice[]) {
    if (!productsForAvailability) return {}
    return deriveAvailableProducts(productsForAvailability)
  }

  export function getColorPriceRanges(productsForAvailability: ProductAvailabilitySlice[]) {
    return deriveColorPriceRanges(productsForAvailability)
  }

  export function getColorGroupsWithUnavailable(
    colorGroups: ColorGroup[],
    productsForAvailability: ProductAvailabilitySlice[],
    selectedFitKey?: string,
    selectedSizeShorthand?: string | null
  ) {
    const availableProducts = getAvailableProducts(productsForAvailability)
    return colorGroups.map(o => ({
      ...o,
      colors: deriveColorsWithUnavailable({
        availableProducts,
        colors: o.colors,
        selectedFitKey: selectedFitKey,
        selectedSizeShorthand: selectedSizeShorthand ?? undefined,
      }),
    }))
  }

  /** Exclude color groups & colors if it exists in the target color groups. */
  export function excludeMatchingColors<T extends ColorGroup>(
    sourceColorGroups: T[],
    targetColorGroups: T[]
  ) {
    return sourceColorGroups.reduce<T[]>((acc, curr) => {
      const targetColorGroup = targetColorGroups.find(({ label }) => label === curr.label)

      // If there is no matching portal color groups for the current color group, return the color group as is
      if (!targetColorGroup) return [...acc, curr]

      // Compute the regular color group colors, excluding those that were returned for portal color groups
      const excludedColors = curr.colors.filter(color => {
        return !existsInColorGroups(color.rawName, targetColorGroup)
      })

      // If there are no colors left after exclusion, continue
      if (excludedColors.length === 0) return acc

      // Otherwise, return the color group with the excluded colors
      return [
        ...acc,
        {
          ...curr,
          colors: excludedColors,
        },
      ]
    }, [])
  }

  export function getColors(productGroup: ProductPageProductGroup) {
    return productGroup.colorGroups.flatMap(o => o.colors)
  }
}
